module.exports = __webpack_public_path__ + "4118807a06c11527d58b5278ef53b3c7.fbx";